import api from "../../api";
import convertCamelKeysToDashCase from "./convertCamelKeysToDashCase";
import getPlacementFromResponse from "../getPlacementFromResponse";

const getAdverts = async (
  sdkParameters,
  parameters,
  displayAdPlacement,
  breakCache
) => {
  const formattedSdkParameters = convertCamelKeysToDashCase(sdkParameters);

  const response = await api(
    {
      ...parameters,
      ...formattedSdkParameters
    },
    breakCache
  );

  return getPlacementFromResponse(response, displayAdPlacement);
};

export default getAdverts;
